import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppData } from '@shared/models/appdata.model';
import { VoiceSubscriptionOffering } from '../models/offerings-response.model';
import { AdditionalServiceSet } from '../models/additional-service-voice.model';

@Injectable({
  providedIn: 'root',
})
export class OfferingService {
  private http = inject(HttpClient);
  private appData = inject(AppData);

  apiUrl = `${this.appData.apiUrl}/api/v1`;

  getDealerOfferings(): Observable<VoiceSubscriptionOffering[]> {
    const offeringUrl = `${this.apiUrl}/product/offerings?b2cOnly=true`;
    return this.http.get<VoiceSubscriptionOffering[]>(offeringUrl, { headers: { 'cache-control': 'no-cache' } });
  }

  getAvailableForChangeOfferings(subscriptionIds: string[]): Observable<VoiceSubscriptionOffering[]> {
    const offeringUrl = `${this.apiUrl}/product/offerings/availableForChange`;
    return this.http.get<VoiceSubscriptionOffering[]>(offeringUrl, {
      params: { subscriptionIds: subscriptionIds.filter(Boolean) },
      headers: { 'cache-control': 'no-cache' },
    });
  }

  getAdditionalServices(offeringId: string): Observable<AdditionalServiceSet> {
    const additionalServiceUrl = `${this.apiUrl}/product/offerings/${offeringId}/additionalServices`;
    return this.http.get<AdditionalServiceSet>(additionalServiceUrl);
  }
}
